/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'
import type {
    AccountAttributeResponseDTO,
    AccountInfoDTO,
    DeleteRequestAccountAttributeParams,
    DevicesWithAuthDTO,
    FeatureFlagsRespDTO,
    GetRequestAccountAttributeParams,
    GetRequestAccountInfoParams,
    GetRequestDevicesParams,
    GetRequestFeatureFlagsParams,
    GetRequestUserGrantsParams,
    GrantInfoResponseDTO,
    HTTPValidationErrorDTO,
    PostRequestAccountAttributeBodies,
    PostRequestAccountAttributeParams,
    PostRequestNameParams,
} from '../../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Get feature list supported by the backend

 * @summary Get Feature Flags
 */
export const getRequestFeatureFlags = (
    params: GetRequestFeatureFlagsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<FeatureFlagsRespDTO>(
        { url: `/feature_flags`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestFeatureFlagsQueryKey = (params?: GetRequestFeatureFlagsParams) => {
    return [`/feature_flags`, ...(params ? [params] : [])] as const
}

export const getGetRequestFeatureFlagsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestFeatureFlags>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFeatureFlagsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestFeatureFlags>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestFeatureFlagsQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestFeatureFlags>>> = ({
        signal,
    }) => getRequestFeatureFlags(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestFeatureFlags>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestFeatureFlagsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestFeatureFlags>>
>
export type GetRequestFeatureFlagsQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestFeatureFlags<
    TData = Awaited<ReturnType<typeof getRequestFeatureFlags>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFeatureFlagsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestFeatureFlags>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestFeatureFlags>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestFeatureFlags>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestFeatureFlags<
    TData = Awaited<ReturnType<typeof getRequestFeatureFlags>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFeatureFlagsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestFeatureFlags>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestFeatureFlags>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestFeatureFlags>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestFeatureFlags<
    TData = Awaited<ReturnType<typeof getRequestFeatureFlags>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFeatureFlagsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestFeatureFlags>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Feature Flags
 */

export function useGetRequestFeatureFlags<
    TData = Awaited<ReturnType<typeof getRequestFeatureFlags>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestFeatureFlagsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestFeatureFlags>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestFeatureFlagsQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This call is used in the login. It retrieves the user account information In the inlogging we call this method with https://a0-test.univex.no/account_info?validity=86400&device_id=fae886eb-0be9-471a-a174-6ea95a002f86&device_name=Capture%20web%201.5&key=KVEz-WDMsj&auth=5xYX44S_Q5SF-KKBTxkvAAuV8yeZ8H8u8Bi6J0Berj&uniquets=1452154975416
Seems like we call this method with some parameters not used on the backend
 * @summary Account Info
 */
export const getRequestAccountInfo = (
    params: GetRequestAccountInfoParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<AccountInfoDTO>(
        { url: `/account_info`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestAccountInfoQueryKey = (params?: GetRequestAccountInfoParams) => {
    return [`/account_info`, ...(params ? [params] : [])] as const
}

export const getGetRequestAccountInfoQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestAccountInfo>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountInfoParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountInfo>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestAccountInfoQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestAccountInfo>>> = ({
        signal,
    }) => getRequestAccountInfo(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestAccountInfo>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestAccountInfoQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestAccountInfo>>
>
export type GetRequestAccountInfoQueryError = ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestAccountInfo<
    TData = Awaited<ReturnType<typeof getRequestAccountInfo>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountInfoParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountInfo>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestAccountInfo>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestAccountInfo>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestAccountInfo<
    TData = Awaited<ReturnType<typeof getRequestAccountInfo>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountInfoParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountInfo>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestAccountInfo>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestAccountInfo>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestAccountInfo<
    TData = Awaited<ReturnType<typeof getRequestAccountInfo>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountInfoParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountInfo>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Account Info
 */

export function useGetRequestAccountInfo<
    TData = Awaited<ReturnType<typeof getRequestAccountInfo>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountInfoParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountInfo>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestAccountInfoQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This api call sets and clears the name of the user.

 * @summary Post Set User Name
 */
export const postRequestName = (
    params: PostRequestNameParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>({ url: `/name`, method: 'POST', params, signal }, options)
}

export const getPostRequestNameMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestName>>,
        TError,
        { params: PostRequestNameParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestName>>,
    TError,
    { params: PostRequestNameParams },
    TContext
> => {
    const mutationKey = ['postRequestName']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestName>>,
        { params: PostRequestNameParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestName(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestNameMutationResult = NonNullable<Awaited<ReturnType<typeof postRequestName>>>

export type PostRequestNameMutationError = ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Post Set User Name
 */
export const usePostRequestName = <TError = ErrorType<HTTPValidationErrorDTO>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestName>>,
            TError,
            { params: PostRequestNameParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestName>>,
    TError,
    { params: PostRequestNameParams },
    TContext
> => {
    const mutationOptions = getPostRequestNameMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This call list out the different devices

 * @summary Get Devices
 */
export const getRequestDevices = (
    params: GetRequestDevicesParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<DevicesWithAuthDTO>(
        { url: `/devices`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestDevicesQueryKey = (params?: GetRequestDevicesParams) => {
    return [`/devices`, ...(params ? [params] : [])] as const
}

export const getGetRequestDevicesQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestDevices>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDevicesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDevices>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestDevicesQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestDevices>>> = ({ signal }) =>
        getRequestDevices(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestDevices>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestDevicesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestDevices>>
>
export type GetRequestDevicesQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestDevices<
    TData = Awaited<ReturnType<typeof getRequestDevices>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDevicesParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDevices>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestDevices>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestDevices>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestDevices<
    TData = Awaited<ReturnType<typeof getRequestDevices>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDevicesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDevices>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestDevices>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestDevices>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestDevices<
    TData = Awaited<ReturnType<typeof getRequestDevices>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDevicesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDevices>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Devices
 */

export function useGetRequestDevices<
    TData = Awaited<ReturnType<typeof getRequestDevices>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestDevicesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestDevices>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestDevicesQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This call is used to get current valid grants for a user

 * @summary Get User Grants
 */
export const getRequestUserGrants = (
    params: GetRequestUserGrantsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<GrantInfoResponseDTO>(
        { url: `/user_grants`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestUserGrantsQueryKey = (params?: GetRequestUserGrantsParams) => {
    return [`/user_grants`, ...(params ? [params] : [])] as const
}

export const getGetRequestUserGrantsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestUserGrants>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserGrantsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestUserGrants>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestUserGrantsQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestUserGrants>>> = ({ signal }) =>
        getRequestUserGrants(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestUserGrants>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestUserGrantsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestUserGrants>>
>
export type GetRequestUserGrantsQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestUserGrants<
    TData = Awaited<ReturnType<typeof getRequestUserGrants>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserGrantsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestUserGrants>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestUserGrants>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestUserGrants>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestUserGrants<
    TData = Awaited<ReturnType<typeof getRequestUserGrants>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserGrantsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestUserGrants>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestUserGrants>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestUserGrants>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestUserGrants<
    TData = Awaited<ReturnType<typeof getRequestUserGrants>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserGrantsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestUserGrants>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get User Grants
 */

export function useGetRequestUserGrants<
    TData = Awaited<ReturnType<typeof getRequestUserGrants>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserGrantsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestUserGrants>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestUserGrantsQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This call is used to upsert account attribute. It will send a client notification of the upsert.

 * @summary Post Account Attribute
 */
export const postRequestAccountAttribute = (
    postRequestAccountAttributeBodies: BodyType<PostRequestAccountAttributeBodies>,
    params: PostRequestAccountAttributeParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<AccountAttributeResponseDTO>(
        {
            url: `/account_attribute`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestAccountAttributeBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestAccountAttributeMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestAccountAttribute>>,
        TError,
        {
            data: BodyType<PostRequestAccountAttributeBodies>
            params: PostRequestAccountAttributeParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestAccountAttribute>>,
    TError,
    {
        data: BodyType<PostRequestAccountAttributeBodies>
        params: PostRequestAccountAttributeParams
    },
    TContext
> => {
    const mutationKey = ['postRequestAccountAttribute']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestAccountAttribute>>,
        {
            data: BodyType<PostRequestAccountAttributeBodies>
            params: PostRequestAccountAttributeParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestAccountAttribute(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestAccountAttributeMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestAccountAttribute>>
>
export type PostRequestAccountAttributeMutationBody = BodyType<PostRequestAccountAttributeBodies>
export type PostRequestAccountAttributeMutationError = ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Account Attribute
 */
export const usePostRequestAccountAttribute = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestAccountAttribute>>,
            TError,
            {
                data: BodyType<PostRequestAccountAttributeBodies>
                params: PostRequestAccountAttributeParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestAccountAttribute>>,
    TError,
    {
        data: BodyType<PostRequestAccountAttributeBodies>
        params: PostRequestAccountAttributeParams
    },
    TContext
> => {
    const mutationOptions = getPostRequestAccountAttributeMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This call is used to get account attributes of a user

 * @summary Get Account Attributes
 */
export const getRequestAccountAttribute = (
    params: GetRequestAccountAttributeParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<AccountAttributeResponseDTO>(
        { url: `/account_attribute`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestAccountAttributeQueryKey = (
    params?: GetRequestAccountAttributeParams,
) => {
    return [`/account_attribute`, ...(params ? [params] : [])] as const
}

export const getGetRequestAccountAttributeQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestAccountAttribute>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountAttributeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountAttribute>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestAccountAttributeQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestAccountAttribute>>> = ({
        signal,
    }) => getRequestAccountAttribute(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestAccountAttribute>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestAccountAttributeQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestAccountAttribute>>
>
export type GetRequestAccountAttributeQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestAccountAttribute<
    TData = Awaited<ReturnType<typeof getRequestAccountAttribute>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountAttributeParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountAttribute>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestAccountAttribute>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestAccountAttribute>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestAccountAttribute<
    TData = Awaited<ReturnType<typeof getRequestAccountAttribute>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountAttributeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountAttribute>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestAccountAttribute>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestAccountAttribute>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestAccountAttribute<
    TData = Awaited<ReturnType<typeof getRequestAccountAttribute>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountAttributeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountAttribute>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Account Attributes
 */

export function useGetRequestAccountAttribute<
    TData = Awaited<ReturnType<typeof getRequestAccountAttribute>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestAccountAttributeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestAccountAttribute>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestAccountAttributeQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This call is used to delete account attributes of a user

 * @summary Delete Account Attributes
 */
export const deleteRequestAccountAttribute = (
    params: DeleteRequestAccountAttributeParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>({ url: `/account_attribute`, method: 'DELETE', params }, options)
}

export const getDeleteRequestAccountAttributeMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestAccountAttribute>>,
        TError,
        { params: DeleteRequestAccountAttributeParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestAccountAttribute>>,
    TError,
    { params: DeleteRequestAccountAttributeParams },
    TContext
> => {
    const mutationKey = ['deleteRequestAccountAttribute']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestAccountAttribute>>,
        { params: DeleteRequestAccountAttributeParams }
    > = (props) => {
        const { params } = props ?? {}

        return deleteRequestAccountAttribute(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestAccountAttributeMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestAccountAttribute>>
>

export type DeleteRequestAccountAttributeMutationError = ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Account Attributes
 */
export const useDeleteRequestAccountAttribute = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestAccountAttribute>>,
            TError,
            { params: DeleteRequestAccountAttributeParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestAccountAttribute>>,
    TError,
    { params: DeleteRequestAccountAttributeParams },
    TContext
> => {
    const mutationOptions = getDeleteRequestAccountAttributeMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
